import React from 'react';
import cn from 'classnames';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import GraderNotes from './GraderNotes';
import CorrectAnswer from './CorrectAnswer';

const AnswerKey = ({
  contentId,
  comments = [],
  questionMetadata = [],
  handleCommentUpdate,
  handleQuestionMetadataUpdate,
  updateGradable,
  applyChanges,
  handleUpdate,
  isPracticeElement,
}) => {
  const onChange = value => {
    applyChanges(value);
    handleUpdate(value);
  };

  return (
    <>
      <div
        className={cn('d-f fd-c pb-16', {
          'pt-40': isPracticeElement,
          'pt-32': !isPracticeElement,
        })}
      >
        <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD} className="as-b pb-4">
          {t('questions.answer_key.title')}
        </Text>
        <Text variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}>
          {t('questions.answer_key.provide_guidance')}
        </Text>
      </div>
      <div className="d-f fd-c mb-16">
        <CorrectAnswer
          contentId={contentId}
          comments={comments}
          questionMetadata={questionMetadata}
          handleCommentUpdate={handleCommentUpdate}
          handleQuestionMetadataUpdate={handleQuestionMetadataUpdate}
          onChange={onChange}
        />
        <GraderNotes
          contentId={contentId}
          comments={comments}
          handleCommentUpdate={handleCommentUpdate}
          updateGradable={updateGradable}
          onChange={onChange}
        />
      </div>
    </>
  );
};

export default AnswerKey;
